import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import DesignCard from '@features/collection/DesignCard';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

const DesignsByCollection = ({
	addNewStyle,
	stylesData,
	setOpenStyleModal,
	collectionId = null,
	folderId = null,
	requestFrom
}) => {
	const [productList, setProductList] = useState(null);
	const [loader, setLoader] = useState(false);
	const location = useLocation();
	const orderCollectionId = new URLSearchParams(location.search).get('collectionId') || collectionId;
	const dispatch = useDispatch();
	const globalLoader = useSelector((store) => store.loaderStore);
	const btnRef = useRef();

	const fetchProducts = async () => {
		try {
			let collectionParams = `${orderCollectionId}?page=0&size=1000&sort=id,asc&collectionId=${orderCollectionId}`;
			let favouriteParams = `?page=0&size=1000&sortingOption=NEWEST&search=&folderId=${folderId}&isDrafted=false&isListView=false`;
			let params = orderCollectionId ? collectionParams : favouriteParams;
			let url = orderCollectionId ? 'getCollectionProducts' : 'getFavouriteProducts';
			if (stylesData.length > 0) {
				const { data } = await ApiClient.GET(url, params);
				let dataList = orderCollectionId ? data.data : data.data.map((item) => item.productResponse);
				let filteredData = dataList.filter((item) => !stylesData.includes(item.id));
				setProductList(filteredData);
			}
		} catch {
			setLoader(false);
		}
	};

	useEffect(() => {
		(async () => {
			setLoader(true);
			await fetchProducts();
			setLoader(false);
		})();
	}, []);

	const createOrder = async (product) => {
		dispatch(openLoader());
		setLoader(true);
		let filteredProduct = productList.filter((item) => item.id !== product.id);
		setProductList(filteredProduct);
		await ApiClient.POST('createOrder', [product.id])
			.then((response) => {
				let data = response.data.map((item) => {
					return {
						...item,
						buyerQuotationType: 'DESIGNWISE',
						sizeWiseBuyerPrice: {},
						colorWiseBuyerPrice: {},
						priceType: 'FOB',
						poNumber: '',
						deliveryDate: '',
						referenceNumber: item?.productReferenceNumber || '',
						isBaseRfq: true
					};
				});
				addNewStyle(data);
				toastSuccess('Style Added');
				setLoader(false);
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				setLoader(false);
				dispatch(closeLoader());
			});
	};

	return (
		<LoaderComponent loading={loader}>
			<div
				className="modal modal-right fade add-multiple-design on-create-order-tab"
				id="add-multiple-design"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="right_modal"
				onBlur={() => {
					if (setOpenStyleModal && !globalLoader) {
						btnRef.current.click();
						setOpenStyleModal(false);
					}
				}}
			>
				<button
					ref={btnRef}
					type="button"
					className="close d-none"
					data-dismiss="modal"
					aria-label="Close"
					aria-hidden="true"
				/>
				<div className="modal-dialog" role="document">
					<div className="modal-content pt-5">
						<DesignCard
							productList={productList || []}
							onScrollList={() => false}
							productIdsOnCollection={[]}
							addToCollection={(product) => createOrder(product)}
							emptyMessage={'No style found!'}
							requestFrom={requestFrom}
						/>
					</div>
				</div>
			</div>
		</LoaderComponent>
	);
};

export default DesignsByCollection;
